<template>
    <div class="link bg-transparent px-3 py-1 rounded inline-block hover:shadow cursor-pointer" @click.prevent="click">
        <span v-if="icon"><i class="fal" :class="(loading == true ? 'fa-spinner fa-spin' : 'fa-' + icon) + (this.$slots.default ? ' mr-1' : '')"></i></span>
        <slot></slot>
    </div>
</template>

<script>
import Helpers from "@/admin/Mixins/GeneralHelpers.js";

export default {
    mixins: [Helpers],

    props: {
        method: null,
        icon: null
    },

    methods: {
        click() {
            this.setLoading(true);
            this.$emit("click");
        }
    }
};
</script>

<style>
.link {
    transition: all, 0.2s;
}
</style>
